"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeModes = void 0;
var BeeModes;
(function (BeeModes) {
    BeeModes["FULL"] = "full";
    BeeModes["LIGHT"] = "light";
    BeeModes["ULTRA_LIGHT"] = "ultra-light";
    BeeModes["DEV"] = "dev";
})(BeeModes = exports.BeeModes || (exports.BeeModes = {}));
